import api from './api';

export const activosService = {
    // Obtener todos los activos
    // NOTA: El backend debe retornar un objeto con estructura:
    // { items: [...], total: number }
    // O simplemente un array para retrocompatibilidad
    getAll: async (params = {}) => {
        const { skip = 0, limit = 100, search, categoria, outservice, ubicacion_id } = params;
        let url = `/activos/?skip=${skip}&limit=${limit}`;

        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        if (categoria) {
            url += `&categoria=${encodeURIComponent(categoria)}`;
        }
        if (outservice !== undefined && outservice !== null) {
            url += `&outservice=${outservice}`;
        }
        if (ubicacion_id) {
            url += `&ubicacion_id=${ubicacion_id}`;
        }

        const response = await api.get(url);
        return response.data;
    },

    // Obtener activo por ID
    getById: async (id) => {
        const response = await api.get(`/activos/${id}`);
        return response.data;
    },

    // Crear activo
    create: async (activoData) => {
        const response = await api.post('/activos/', activoData);
        return response.data;
    },

    // Actualizar activo
    update: async (id, activoData) => {
        const response = await api.put(`/activos/${id}`, activoData);
        return response.data;
    },

    // Eliminar activo
    delete: async (id) => {
        const response = await api.delete(`/activos/${id}`);
        return response.data;
    },

    // Subir Excel
    uploadExcel: async (file) => {
        const formData = new FormData();
        formData.append('file', file);

        const response = await api.post('/activos/upload-excel', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    },

    // Exportar Excel
    exportExcel: async () => {
        const response = await api.get('/activos/export/excel', {
            responseType: 'blob'
        });

        // Crear enlace de descarga
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'activos.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    },

        // Obtener QR del activo
        getQR: async (id) => {
            const response = await api.get(`/activos/${id}/qr?format=json`);
            return response.data;
        },

        // Obtener imagen QR del activo
        getQRImage: async (id) => {
            const response = await api.get(`/activos/${id}/qr?format=image`, {
                responseType: 'blob'
            });
            return response.data;
        },

        // Regenerar QR del activo
        regenerateQR: async (id) => {
            const response = await api.post(`/activos/${id}/regenerate-qr`);
            return response.data;
        },
          downloadTemplate: async () => {
        try {
            // Crear enlace directo al archivo en la carpeta template
            const templatePath = '/template/Plantilla_Activos_Argus.xlsx';
            
            // Crear enlace de descarga
            const link = document.createElement('a');
            link.href = templatePath;
            link.download = 'Plantilla_Activos_Argus.xlsx';
            link.target = '_blank'; // Abrir en nueva pestaña como fallback
            
            // Trigger descarga
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            return { 
                success: true, 
                filename: 'Plantilla_Activos_Argus.xlsx'
            };
        } catch (error) {
            console.error('Error downloading template:', error);
            throw error;
        }
    },
        // Descargar QR individual
    downloadQR: async (id) => {
        try {
            const response = await api.get(`/activos/${id}/qr/download`, {
                responseType: 'blob'
            });

            // Crear enlace de descarga
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            
            // Obtener nombre del archivo desde headers o usar nombre por defecto
            const contentDisposition = response.headers['content-disposition'];
            let filename = `QR_Activo_${id}.png`;
            
            if (contentDisposition) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(contentDisposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }
            
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            
            return { success: true, filename };
        } catch (error) {
            console.error('Error downloading QR:', error);
            throw error;
        }
    },

    // Descargar todos los QR en PDF
    downloadAllQRsPDF: async () => {
        try {
            const response = await api.get('/activos/qr/download-all-pdf', {
                responseType: 'blob'
            });

            // Crear enlace de descarga
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            
            // Obtener nombre del archivo
            const contentDisposition = response.headers['content-disposition'];
            let filename = 'Codigos_QR_Activos.pdf';
            
            if (contentDisposition) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(contentDisposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }
            
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            
            return { success: true, filename };
        } catch (error) {
            console.error('Error downloading QR PDF:', error);
            throw error;
        }
    },

    // Descargar QR en ZIP
    downloadAllQRsZIP: async () => {
        try {
            const response = await api.get('/activos/qr/download-all-zip', {
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            
            const contentDisposition = response.headers['content-disposition'];
            let filename = 'Codigos_QR_Activos.zip';
            
            if (contentDisposition) {
                const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = filenameRegex.exec(contentDisposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }
            
            link.setAttribute('download', filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            
            return { success: true, filename };
        } catch (error) {
            console.error('Error downloading QR ZIP:', error);
            throw error;
        }
    },

    
};
